import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "input", "message"];

  formToJSON(inputs) {
    return [].reduce.call(inputs, function(data, element) {
      data[element.name] = element.value;
      return data;
    });
  }

  getUrlString(data) {
    const urlParameters = Object.entries(data)
      .map(function(e) {
        return e.join("=");
      })
      .join("&");

    return urlParameters;
  }

  async handleSubmit(e) {
    e.preventDefault();

    const body = this.getUrlString(this.formToJSON(this.inputTargets));

    try {
      const res = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body,
      });

      if (res.ok) {
        this.messageTarget.classList.add("enquiry-form__message--success");
        this.messageTarget.innerText =
          "Thanks, your message has now been sent. We will get back to you soon.";
      } else {
        console.error(`There was an error with status: ${res.status}`);
      }
    } catch (error) {
      this.messageTarget.classList.add("enquiry-form__message--failure");
      this.messageTarget.innerText =
        "Uh oh, something went wrong. Please check the form has been filled in correctly and try again.";
      console.error(`There was an error, ${error}`);
    }
  }
}
